import React, {type FC, useMemo} from 'react';

import Breadcrumbs, {type BreadcrumbPart} from '../../../Breadcrumbs';
import {type SEOBreadcrumb} from './utils';

export type NavBreadcrumbsSEOProps = {
  breadcrumbs: SEOBreadcrumb[];
};

export function useNavBreadcrumbsSEOParts({
  breadcrumbs = [],
}: NavBreadcrumbsSEOProps): BreadcrumbPart[] {
  const parts: BreadcrumbPart[] = useMemo(
    () => breadcrumbs.map(({name, path}) => ({label: name, to: path})),
    [breadcrumbs]
  );

  return parts;
}

const NavBreadcrumbsSEO: FC<NavBreadcrumbsSEOProps> = params => {
  const parts = useNavBreadcrumbsSEOParts(params);
  return <Breadcrumbs parts={parts} />;
};

export default NavBreadcrumbsSEO;
